import Types from "./Types";

const viewsCountFromPayload = (payload) => {
  const fromResponse = payload?.result?.data?.data?.views_count;
  if (typeof fromResponse === "number" || typeof fromResponse === "string") {
    return Number(fromResponse);
  }
  if (payload?.payload?.views_count != null) {
    return Number(payload.payload.views_count);
  }
  return null;
};

export const patchVideoViews = (video, payload, replaceRecord = false) => {
  if (!video || String(video.id) !== String(payload?.payload?.video_id)) {
    return video;
  }

  const record = payload?.result?.data?.data;
  const nextCount = viewsCountFromPayload(payload);

  if (replaceRecord) {
    const viewsRecord =
      record && typeof record === "object"
        ? { ...record }
        : { views_count: nextCount };
    if (nextCount != null && !Number.isNaN(nextCount)) {
      viewsRecord.views_count = nextCount;
    }
    return { ...video, views_count: viewsRecord };
  }

  const previous =
    video.views_count && typeof video.views_count === "object"
      ? video.views_count
      : {};
  const merged =
    record && typeof record === "object" ? { ...previous, ...record } : { ...previous };
  if (nextCount != null && !Number.isNaN(nextCount)) {
    merged.views_count = nextCount;
  }
  return { ...video, views_count: merged };
};

const applyViewsUpdate = (state, payload, replaceRecord) => {
  const chapterVideos = (state.chapterVideos || []).map((video) =>
    patchVideoViews(video, payload, replaceRecord)
  );
  const videoDetails = patchVideoViews(state.videoDetails, payload, replaceRecord);
  return {
    ...state,
    chapterVideos,
    videoDetails,
  };
};

const INITIAL_STATE = {
  chapterVideos: [],
  videoDetails: {},
  videoData: {},
  liveVideo: [],
  seenCount: 0,
  otp: "",
  playbackInfo: "",
  count: "",
  loading: false,
  seenLoading: false,
  voucherLoading: false,
};

export default function chaptervideos(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_VIDEOS_BY_CHAPTER_ID_SUCCESS: {
      return {
        ...state,
        chapterVideos: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_VIDEO_BY_ID_SUCCESS: {
      return {
        ...state,
        videoDetails: payload.data,
      };
    }

    case Types.VIDEO_DATA_SUCCESS: {
      return {
        ...state,
        videoData: payload?.result?.data?.data,
      };
    }
    case Types.CREATE_SEEN_COUNT_SUCCESS: {
      return applyViewsUpdate(state, payload, true);
    }
    case Types.UPDATE_SEEN_COUNT_SUCCESS: {
      return applyViewsUpdate(state, payload, false);
    }

    case Types.GET_VIDEO_OTP_SUCCESS: {
      return {
        ...state,
        playbackInfo: payload.playbackInfo,
        otp: payload.otp,
      };
    }

    case Types.GET_LIVE_VIDEO_SUCCESS: {
      return {
        ...state,
        liveVideo: payload.data,
      };
    }

    case Types.MORE_VIDEO_VIEWS_SUCCESS: {
      return {
        ...state,
      };
    }

    case Types.ADD_VIDEOS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.VIDEO_SEEN_LOADING: {
      return {
        ...state,
        seenLoading: payload,
      };
    }

    case Types.VIDEO_VOUCHER_LOADING: {
      return {
        ...state,
        voucherLoading: payload,
      };
    }
    default: {
      return state;
    }
  }
}
